import React from 'react';
import '../svg.css';


const IT = props => {
    const { fill } = props;
    return (
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"
            height="36px"
            width="36px"
            className='svg'
        >
            <g id="messages_IT" data-name="messages/IT"><g id="Logo"><rect id="frame" className="IT-1" width="36" height="36" rx="10" /></g><rect id="bound" className="IT-2" x="6" y="6" width="24" height="24" /><rect id="Combined-Shape" className="IT-3" x="9" y="19" width="18" height="7" rx="2" /><path id="Combined-Shape-2" data-name="Combined-Shape" className="IT-4" d="M18,13a7,7,0,0,1,5.4,2.55l-1.54,1.27a5,5,0,0,0-7.71,0l-1.54-1.28A7,7,0,0,1,18,13Zm0-4a11,11,0,0,1,8.47,4l-1.54,1.28a9,9,0,0,0-13.85,0L9.54,13A11,11,0,0,1,18,9Z" /></g>
        </svg>);
};

export default IT;
